// Story 21-A/21-B — shared vs-last-month delta display logic, used by both the summary tiles
// (ReportMetricTile) and the staff scorecard table's inline delta cells, so the two surfaces
// can never drift on what "up"/"down"/no-data means.
//
// `metric` is a MetricComparison ({ thisMonth, lastMonth, deltaAbsolute, deltaPercent }); a null
// deltaPercent (no prior-month data) means no delta to show.
//
// `coloring`:
//  - 'neutral' (hours/cost/leave-days): signed % only, no green/red — "up" isn't inherently good.
//  - 'inverse' (no-shows/late-arrivals): down is good (green), up is bad (red).
export function computeDeltaDisplay(metric, coloring = 'neutral') {
  const hasDelta = metric?.deltaPercent !== null && metric?.deltaPercent !== undefined;

  let deltaClass = 'text-gray-400';
  let direction = null; // 'up' | 'down' | null

  if (hasDelta) {
    const pct = metric.deltaPercent;
    if (coloring === 'inverse') {
      deltaClass = pct < 0 ? 'text-green-600' : pct > 0 ? 'text-red-600' : 'text-gray-500';
    } else {
      deltaClass = 'text-gray-600';
    }
    if (pct > 0) direction = 'up';
    else if (pct < 0) direction = 'down';
  }

  return {
    hasDelta,
    deltaClass,
    direction,
    absPercent: hasDelta ? Math.abs(metric.deltaPercent) : null,
  };
}
